import { render } from "./table-action-change-display.vue?vue&type=template&id=996064de"
import script from "./table-action-change-display.vue?vue&type=script&lang=js"
export * from "./table-action-change-display.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__